import "./App.css";
import Homepage from "./pages/Homepage";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./styles/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EntryPage from "./pages/EntryPage";
import { useEffect } from "react";
import RegisterUser from "./pages/RegisterUser";
import LoginPage from "./pages/LoginPage";
import NotFound from "./pages/NotFound";
import useAuth, { Authentication } from "./useAuth";
import { ProfilePage } from "./pages/ProfilePage";
import SharedPage from "./pages/SharedPage";
import ActivityPage from "./pages/ActivityPage";
import HistoryPage from "./pages/HistoryPage";
import TrashPage from "./pages/TrashPage";
import PrivatePage from "./pages/PrivatePage";
import { ActivityProvider } from "./ActivityContext";
import OrganizationPage from "./pages/OrganizationPage";

function App() {
  const Scroll = (props) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };

  return (
    <BrowserRouter>
      <ToastContainer position="bottom-center" autoClose={2000} hideProgressBar={true} />
      <Authentication>
        <ActivityProvider>
          <Scroll>
            <Routes>
              <Route path="login" element={<LoginPage />} />
              <Route path="*" element={<NotFound />} />
              <Route path="/" element={<Navigate to="/my" />} />
              <Route path="/my" element={<EntryPage />}>
                <Route path="" element={<Navigate to="home" />} />
                <Route path="home" element={<Homepage />} />
                <Route path="shared" element={<SharedPage />} />
                <Route path="private" element={<PrivatePage />} />
                <Route path="registerUser" element={<RegisterUser />} />
                <Route path="activity" element={<ActivityPage />} />
                <Route path="history" element={<HistoryPage />} />
                <Route path="trash" element={<TrashPage />} />
                <Route path="profile" element={<ProfilePage />} />
                <Route path="organization" element={<OrganizationPage />} />
              </Route>
            </Routes>
          </Scroll>
        </ActivityProvider>
      </Authentication>
    </BrowserRouter>
  );
}

export default App;
